import { render, staticRenderFns } from "./link_red.vue?vue&type=template&id=16a99d95"
import script from "./link_red.vue?vue&type=script&lang=js"
export * from "./link_red.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports